import React from "react";
import { useTranslation } from "react-i18next";
import { basicBoxesList, categoryColors } from "../Boxes/utils";

const boxCatalogByType = {};
basicBoxesList.forEach((box) => {
    boxCatalogByType[box.type] = box;
});

export function getBoxCatalogEntry(type) {
    return boxCatalogByType[type] || null;
}

export function collectUnknownBoxTypes(nodes) {
    let unknownTypes = [];
    (nodes || []).forEach((node) => {
        if (!getBoxCatalogEntry(node.type) && !unknownTypes.includes(node.type)) {
            unknownTypes.push(node.type);
        }
        collectUnknownBoxTypes(node.children).forEach((childType) => {
            if (!unknownTypes.includes(childType)) unknownTypes.push(childType);
        });
    });
    return unknownTypes;
}

export function countTreeNodes(nodes) {
    let count = 0;
    (nodes || []).forEach((node) => {
        count += 1 + countTreeNodes(node.children);
    });
    return count;
}

function summarizeNodeProperties(node) {
    let properties = node.properties || {};
    if (node.type === "label_box") return properties.label || null;
    if (properties.field_path) return properties.field_path;
    if (properties.variable_name) return properties.variable_name;
    if (properties.value !== undefined && properties.value !== null && properties.value !== "") {
        return String(properties.value);
    }
    return null;
}

function MiniRuleTreeNode({ node, depth, t }) {
    let catalogEntry = getBoxCatalogEntry(node.type);
    let summary = summarizeNodeProperties(node);

    return (
        <div className="qia-mini-node-block">
            <div className="qia-mini-node-row" style={{ marginLeft: depth * 14 + "px" }}>
                {catalogEntry ? (
                    <span
                        className="qia-mini-node-icon"
                        style={{ backgroundColor: categoryColors(catalogEntry.category) }}
                    >
                        <img src={catalogEntry.logoSVG} alt="" />
                    </span>
                ) : (
                    <span className="qia-mini-node-icon qia-mini-node-icon-unknown">?</span>
                )}
                <span className="qia-mini-node-name">
                    {catalogEntry ? t(catalogEntry.description) : node.type}
                </span>
                {summary && <span className="qia-mini-node-summary">{summary}</span>}
            </div>
            {(node.children || []).map((child, index) => (
                <MiniRuleTreeNode key={index} node={child} depth={depth + 1} t={t} />
            ))}
        </div>
    );
}

// Compact, read-only rendering of a rule fragment in the persisted
// (outcome) node shape: {type, properties, children, metadata}.
function MiniRuleTree({ treeData }) {
    const { t } = useTranslation();
    return (
        <div className="qia-mini-tree">
            {(treeData || []).map((node, index) => (
                <MiniRuleTreeNode key={index} node={node} depth={0} t={t} />
            ))}
        </div>
    );
}

export default MiniRuleTree;
